import { manufacturingFetch } from "@/lib/manufacturingClient";
import type { SkuSerialConvention } from "@/lib/manufacturing/skuSerialConvention";

export function getManufacturingOrgSerialConvention() {
  return manufacturingFetch<{
    ok: true;
    settings: SkuSerialConvention;
    persisted: boolean;
  }>("/api/mfg/org-serial-convention", { method: "GET" });
}

export function upsertManufacturingOrgSerialConvention(settings: SkuSerialConvention) {
  return manufacturingFetch<{ ok: true; settings: SkuSerialConvention }>(
    "/api/mfg/org-serial-convention/upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(settings),
    },
  );
}
